import { IntegrationProvider } from "@repo/app-types/entities/integration";
import type { FC } from "react";
import {
  checkAlpharunOperatedIntegrationEnabled,
  useAlpharunOperatedIntegrationDetailOutletContext,
} from "./alpharunOperatedIntegrationDetailSection.js";
import { RecordingImportsTab } from "./recordingImportsTab.js";

/**
 * The **Failed imports** tab of an Alpharun-operated integration: the generic
 * recording-imports surface over the company's row.
 */
export const AlpharunOperatedIntegrationImportsTab: FC = () => {
  const { integration, config } =
    useAlpharunOperatedIntegrationDetailOutletContext();
  // Only failed rows are listed here, so the API upload copy says where the
  // rest of the caller's imports are.
  const description =
    integration.provider === IntegrationProvider.API_RECORDING_UPLOAD
      ? "Recordings sent to the recording import endpoints that couldn't be imported. Successful imports appear with your other recordings. Use GET /recording-imports/:id to check an upload that's still in progress. Reprocess a recording to try importing it again, or skip it to dismiss it."
      : `Call recordings from ${config.name} that couldn't be imported. Reprocess a recording to try importing it again, or skip it to dismiss it.`;
  // While Alpharun has paused the import, the API refuses reprocess and skip
  // (400), so the tab hides the actions.
  return (
    <RecordingImportsTab
      integrationId={integration.id}
      provider={integration.provider}
      isPaused={!checkAlpharunOperatedIntegrationEnabled(integration)}
      description={description}
    />
  );
};
